import { useEffect, useState } from 'react'
import { LOGIN_PATH, LOGIN_REDIRECT_PATH } from './constants/RoutePaths'
import { setActiveAccessToken } from './helpers/AuthorizationHelpers'
import userManager from './helpers/UserManager'

const AuthProvider = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false)

  useEffect(() => {
    const pathname = window.location.pathname

    if (
      pathname.includes(LOGIN_REDIRECT_PATH) ||
      pathname.includes(LOGIN_PATH) ||
      pathname.includes('/register/') ||
      pathname.includes('/public/')
    ) {
      setAuthChecked(true)
      return
    }

    const checkAuth = async () => {
      try {
        const user = await userManager.getUser()

        if (user && !user.expired) {
          setActiveAccessToken(user.access_token, user.expires_at * 1000)
          setAuthChecked(true)
        } else {
          if (!pathname.includes(LOGIN_PATH) && !pathname.includes('/public/') && !pathname.includes('/register/')) {
            await userManager.signIn()
          }
        }
      } catch {
        setAuthChecked(true)
      }
    }

    checkAuth()
  }, [])

  if (!authChecked) return null

  return children
}

export default AuthProvider
